import styled from "styled-components";
import { IconButton, TableCell } from "@mui/material";

export const TableGrid = styled.div`
	display: -webkit-box;
	-webkit-line-clamp: 1;
	overflow: hidden;
	-webkit-box-orient: vertical;
	word-break: break-all;
`;

export const TableCellGrid = styled(TableCell)`
	&&& {
		min-width: 100px;
		width: 160px;
		max-width: 160px;
	}
`;

export const TableCellGridAction = styled(TableCell)`
	&&& {
		min-width: 10%;
		width: 10%;
		max-width: 10%;
	}
`;

export const ButtonEditIcon = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.pantoneBlack};
	}
`;

export const ButtonCloseIcon = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.red};
	}
`;
